// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import Chart from "chart.js/auto";
import './stylesheets/application.scss'
import * as bootstrap from 'bootstrap'
import "@fortawesome/fontawesome-free/css/all.css";
import Dropzone from "dropzone";

Rails.start()
ActiveStorage.start()

require('select2')
window.Chart = Chart
global.toastr = require("toastr")

window.jQuery = $;
window.$ = $;

$(document).on("turbo:load", () => {
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  })

  $('.select2').select2();

  $('.add_fields').click(function(e) {
    e.preventDefault();
    var link = e.target;
    if (link.dataset.fields === undefined) {
      link = e.target.closest('[data-fields]')
    }

    let time = new Date().getTime();
    let linkId = link.dataset.id;
    let regexp = linkId ? new RegExp(linkId, 'g') : null ;
    let newFields = regexp ? link.dataset.fields.replace(regexp, time) : null;
    newFields ? link.insertAdjacentHTML('beforebegin', newFields) : null;

  });

  $('.form-group').on('click','.remove_fields', function(e) {
    e.preventDefault();
    var link = e.target;
    let fieldParent = link.closest('.nested-fields');
    let deleteField = fieldParent ? fieldParent.querySelector('input[type="hidden"]') : null;
    if (deleteField) {
      deleteField.value = 1;
    }
    if (fieldParent) {
      fieldParent.style.display = 'none';
      if ($(link).closest('span.remove_fields').data('remove') !== undefined) {
        fieldParent.remove();
      }
    }
  });

  Dropzone.autoDiscover = false;

  if ($("#documentDropzone").length > 0) {
    let myDropzone = new Dropzone("#documentDropzone");
    myDropzone.on("addedfile", file => {
    });

    myDropzone.on("success", (file, response) => {
      Turbo.visit("/transactions/creating", { "action":"replace" });
    });

    $("#documentDropzone #file").on("change", function(e) {
      $("#documentDropzone").submit();
    });
  }

  if ($('#entities_by_risk').length) {
    var config = $('#entities_by_risk').data('config');
    var ctx = document.getElementById('entities_by_risk').getElementsByTagName('canvas')[0].getContext('2d');
    new Chart(ctx, config);
  }
});